import fetchProduct from "../helpers/useProduct/fetchProduct";
import formatDatalayerEcommerce from "../helpers/formatDatalayerEcommerce";

class DlViewItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.viewed) return;

    // Read before the fetch: the modal can be closed — taking the element and
    // the look's mode with it — before the product resolves.
    const customProperties = {
      is_quick_view: this.isQuickView,
      is_product_set: this.isProductSet,
      is_shop_the_look: this.isShopTheLook,
    };

    fetchProduct(this.productId).then((product) => {
      const variantId = this.initialVariantId;
      const variant = product.variants.find(
        (variant) => variant.id === variantId,
      );

      const ecommerce = formatDatalayerEcommerce({
        product,
        variant,
        key: "detail",
        customProperties,
      });

      setTimeout(() => {
        // Wait a bit for stock messaging to render.
        // This should be reliably quick since it relies on the same (now cached) fetchProduct data
        // We want the messaging to be in the DOM before pushing this because we grab and append
        // the stock message in ElevarTransformFn.
        window.ElevarDataLayer?.push({
          event: "dl_view_item",
          ...ecommerce,
        });
      }, 250);
    });

    this.viewed = true;
  }

  disconnectedCallback() {}

  get productId() {
    return this.getAttribute("product-id");
  }

  get initialVariantId() {
    return this.getAttribute("initial-variant-id");
  }

  get isQuickView() {
    return this.hasAttribute("is-quick-view");
  }

  get isProductSet() {
    return this.hasAttribute("is-product-set");
  }

  get isShopTheLook() {
    return !!this.closest("markup-modal[shop-the-look]");
  }
}

if (!customElements.get("dl-view-item")) {
  customElements.define("dl-view-item", DlViewItem);
}
